export const EN = { code: 'en', language: 'English' }
export const ZHTW = { code: 'zh-TW', language: '繁體中文' }

export const allLanguages = [
  EN,
  ZHTW
]
